export const errorInArray = async (callback = () => {}) => {
  try {
    const data = await callback();
    return [data, null];
  } catch (err) {
    return [null, err];
  }
};
